import React, { Component } from 'react';
import axios from './utils/axios';

import Paso1 from './components/Paso1';
import Paso2 from './components/Paso2';
import Paso3 from './components/Paso3';

class Simulacion extends Component {
  constructor(props) {

    super(props); 
    
    this.state = {
      data: [],
      isLoading: true,
    }

    this.tokenValidation = this.tokenValidation.bind(this)
    
  }
  componentWillMount() {
    this.tokenValidation()
  }

  async tokenValidation() {

    const localToken = localStorage.getItem('token')

    const options = {
        headers: {
            'Content-Type': 'application/json',
            'token': localToken
        }
    };

    if(!localToken) {
        return false
    }
    try {
        const {status, data } = await axios.post("api/v1/simulacion/getInfoByToken", {}, options)
        if (status === 200) {
            
            this.setState({ data: data, isLoading: false});
            return true;
        }
    } catch (error) {
        return false;
    }
   
  }

  render() {

      switch(this.state.data.step) {

        case 'step1':
          return <div><Paso1 name="Paso1" data={this.state.data} /></div>
      
        case 'step2':
          return <div><Paso2 name="Paso2" data={this.state.data} /></div>
      
        case 'step3':
            return <div><Paso3 name="Paso3" data={this.state.data} /></div>
      
        default:
          return <div><Paso1 name="Paso1" data={this.state.data} /></div>

      } // end switch
        
    } //end render

}

export default Simulacion;
